import React, { ReactNode } from 'react';
import { Clock } from 'react-bootstrap-icons';

import ChangeIcon from '../../../../General/ChangeIcon';
import { PropertyAttribute } from './PropertyAttribute';

import { UpcomingChange } from '../../../../../Interface/Response/Interest/PropertyAttributes';
import { ValueType } from '../../../../../Enum/ProductProperties/ValueType';

import { convertStringToDutchString } from '../../../../../Helpers/Date';

interface Props {
    change: UpcomingChange;
}

const getContent = (change: UpcomingChange): ReactNode => {
    const date = convertStringToDutchString(change.date);

    if (change.infoExpanded === true) {
        return <>Op <strong>{date}</strong> vindt er een wijziging plaats van deze voorwaarde.</>;
    }

    if (change.value !== undefined) {
        return <>Op <strong>{date}</strong> vindt er een wijziging plaats van deze voorwaarde naar <strong><PropertyAttribute value={change.value} type={change.type as ValueType} /></strong>.</>;
    }

    const type = change.remark !== undefined ? 'aanvulling' : 'info';
    return <>Op <strong>{date}</strong> vindt er een wijziging plaats in de {type} van deze voorwaarde.</>;
}

const UpcomingChangeIcon: React.FC<Props> = ({ change }) => (
    <ChangeIcon
        title="Wijziging"
        content={getContent(change)}
        icon={<Clock className="ml-1" />}
    />
);

export default UpcomingChangeIcon;
